type JsonHighlightProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    object: any
    className?: string
}
const JsonHighlight = (props: JsonHighlightProps) => {
    const { object, className } = props
    const str = JSON.stringify(object, undefined, 2)

    const highlightJson = (json: string) => {
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        return json.replace(
            /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+git -]?\d+)?)/g,
            (content) => {
                let style = 'text-brand-primary' // number
                if (/^"/.test(content)) {
                    if (/:$/.test(content)) {
                        style = 'text-brand-secondary' // key
                    } else {
                        style = 'text-green-dark' // string
                    }
                } else if (/true|false/.test(content)) {
                    style = 'text-orange' // boolean
                } else if (/null/.test(content)) {
                    style = 'text-grey-dark' // null
                }
                return '<span class="' + style + '">' + content + '</span>'
            }
        )
    }

    return (
        <pre
            className={`whitespace-pre-wrap break-words max-w-prose mt-3 ${className ?? ''}`}
            // TODO: Consider finding other solution than dangerouslySetInnerHtml - MINT-605
            dangerouslySetInnerHTML={{
                __html: highlightJson(str),
            }}
        ></pre>
    )
}

export default JsonHighlight
